module.exports = __webpack_public_path__ + "img/75631.21db06e3.svg";